"use strict";
import { LOADING_ANNOTATIONS } from "../actions";
export default function documentPageIdReducer(id = null, action) {
  switch (action.type) {
    case LOADING_ANNOTATIONS: {
      return action.id;
    }
    default:
      return id;
  }
}
